/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Col_PointsInputs */



/**
* | output |
* | --- |
* | "RtP" |
*
* @param {Rankings_Col_PointsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_col_points = /** @type {((inputs?: Rankings_Col_PointsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Col_PointsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "es") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "it") return /** @type {LocalizedString} */ ("RtP")
	return /** @type {LocalizedString} */ ("RtP")
});